import Lottie from 'lottie-react';

import animationData from './DLoaderWritingLottie.json';

const DLoaderWriting = ({ style }) => {
  return (
    <div className="d-loader-write" style={style}>
      <style>{`.d-loader-write svg path {fill: var(--dt-color-element-100);}`}</style>
      <Lottie
        isClickToPauseDisabled
        ariaRole=""
        animationData={animationData}
        loop={true}
        autoplay={true}
        style={{ height: 32, width: 32, margin: 0 }}
        eventListeners={[]}
      ></Lottie>
    </div>
  );
};

export default DLoaderWriting;
